var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticStyle:{"top":"0px","left":"0px"}},[_c('b-alert',{staticStyle:{"justify-content":"center","font-size":"1rem","border-radius":"0px"},attrs:{"show":_vm.dismissCount,"dismissible":"","variant":"warning"},on:{"dismissed":_vm.onDismissed}},[_vm._v(_vm._s(_vm.alertMessage))])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }